import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading, null = anon
    const [checking, setChecking] = useState(true);

    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem("lakshmi_token");
        if (!token) { setUser(null); setChecking(false); return; }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("lakshmi_token");
            setUser(null);
        } finally {
            setChecking(false);
        }
    }, []);

    useEffect(() => { bootstrap(); }, [bootstrap]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("lakshmi_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (email, password, name) => {
        const { data } = await api.post("/auth/register", { email, password, name });
        localStorage.setItem("lakshmi_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("lakshmi_token");
        setUser(null);
    };

    const refreshUser = async () => {
        const { data } = await api.get("/auth/me");
        setUser(data);
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, setUser, checking, login, register, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
